import React from "react";
import AuthSignupButton from "./AuthSignupButton";

const SignupButton = () => {
  return <AuthSignupButton className="signup-btn" />;
};

export default SignupButton; 